export const calcPorcentaje = (total, cantidad) => {
  return (100 * cantidad) / total
}

export const trimMean = (values, percent = 0.1) => {
  if (!Array.isArray(values) || values.length === 0) {
    return 0
  }
  const sortedValues = [...values].sort((a, b) => a - b)
  const totalElementsToTrim = Math.floor(values.length * percent)
  const totalElementsToTrimPerSide = Math.floor(totalElementsToTrim / 2)

  const trimmed = sortedValues.slice(
    totalElementsToTrimPerSide,
    sortedValues.length - totalElementsToTrimPerSide
  )

  const sum = trimmed.reduce((acc, val) => acc + val, 0)
  return sum / trimmed.length
}

export const gcd = (a, b) => (!b ? a : gcd(b, a % b))
export const gcdMultiple = (...arr) => arr.reduce((a, b) => gcd(a, b))
